import PropTypes from 'prop-types';
import Settings03Icon from '@untitled-ui/icons-react/build/esm/Settings03';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

export const SettingsButton = (props) => {
  const { floating = true, small = false, ...other } = props;
  const { t } = useTranslation();

  return (
    <Tooltip title={t('components.settingsButton.settings')}>
      <Box
        sx={{
          ...(floating
            ? {
                backgroundColor: 'background.paper',
                borderRadius: '50%',
                bottom: 0,
                boxShadow: 16,
                margin: (theme) => theme.spacing(4),
                position: 'fixed',
                right: 0,
                zIndex: (theme) => theme.zIndex.speedDial,
              }
            : {}),
        }}
        {...other}
      >
        <ButtonBase
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: '50%',
            color: 'primary.contrastText',
            p: small ? '6px' : '10px',
          }}
        >
          <SvgIcon
            sx={{
              fontSize: small ? 18 : 24,
            }}
          >
            <Settings03Icon />
          </SvgIcon>
        </ButtonBase>
      </Box>
    </Tooltip>
  );
};

SettingsButton.propTypes = {
  floating: PropTypes.bool,
  small: PropTypes.bool,
  onClick: PropTypes.func,
};
